import React, { useEffect, useState } from "react";
import LeadsTable from "../Table/LeadsTable";
import LeadsFilterSearch from "./LeadsFilterSearch";

import { Alert, AlertTitle, Grid } from "@mui/material";
import LeadersSearchHeader from "./LeadersSearchHeader";
import {
  dealFilterAction,
  dealsFindAction,
  dealsFindActionWithoutPagination,
  deleteLeadAction,
  leadFindAction
} from "../../actions/leadActions/leadActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { findUserAction } from "../../actions/adminAuthAction";
import DownloadExcel from "../extraComponents/DownloadExcel";
import DownloadPdf from "../extraComponents/DownloadPdf";
import axios from "axios";
import Loader from "../LoaderComponent/Loader";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";

function DealsMain(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [data, setData] = useState([]);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [counsilorNote, setCounsilorNote] = useState({});
  const [teleCallerNote, setTeleCallerNote] = useState({});
  const [marketingNote, setMarketingNote] = useState({});
  const [viewedColumn, setViewedColumn] = useState([]);
  const [columnVisibilityData, setColumnVisibilityData] = useState([]);
  const [searchPagination, setSearchPagination] = useState(false)
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [searchValue, setSearchValue] = useState('');
  const [filterPagination, setFilterPagination] = useState(false)
  const [currentFilterData, setCurrentFilterData] = useState(null);  

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // let { leadFindLoading, leadFindSuccess } = useSelector((state) => {
  //   return state.leadFind;
  // });

  const { dealsFindLoading, dealFindSuccess } = useSelector((state) => state.dealFind)  

  const { dealFilterSuccess } = useSelector((state) => state.dealFilter)

  const { dealsFindWithoutPaginationSuccess } = useSelector((state) => state.dealFindWithoutPagination)
  
  let { leadAddSuccess } = useSelector((state) => {
    return state.leadAdd;
  });

  let { leadDeleteSuccess } = useSelector((state) => {
    return state.deleteLead;
  });

  let { leadOwnerSuccess } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  let { loginFindSuccess } = useSelector((state) => {
    return state.findUser;
  });
  
  useEffect(() => {
    dispatch(findUserAction());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(leadFindAction());
  // }, [dispatch, leadAddSuccess, leadDeleteSuccess, leadOwnerSuccess]);

  useEffect(() => {
    if (!searchPagination && !filterPagination || leadOwnerSuccess) {
      dispatch(dealsFindAction(pagiantionEntry, paginationPageNumber))
      dispatch(dealsFindActionWithoutPagination())
    }
  }, [
    dispatch,
    leadAddSuccess,
    leadDeleteSuccess,
    leadOwnerSuccess,
    pagiantionEntry,
    paginationPageNumber,
    searchPagination,
    filterPagination
  ])

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col;
      }
    });
    setColumnVisibilityData(columnVisibilityData);
  }, [viewedColumn]);

  console.log(105,dealFindSuccess);
  

  useEffect(() => {
    if (dealFindSuccess || reset) {
      setLeadData(dealFindSuccess?.allLeads);

      const latestTeleCallerNote = dealFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestCounsilorNote = dealFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestMarketingNote = dealFindSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_marketing_notes &&
            current.lead_marketing_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_marketing_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_marketing_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date
      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
      setMarketingNote(latestMarketingNote);
    }
  }, [dealFindSuccess, reset]);

  console.log(201,dealFindSuccess?.allLeads?.length);
  

  useEffect(() => {
    if (dealFilterSuccess || reset) {
      if (dealFindSuccess?.allLeads?.length === 0 || dealFindSuccess !== undefined) {
        setFilterPagination(true);
      } 
      setPaginationPageNumber(1);
      setLeadData(dealFilterSuccess?.allLeads);

      const latestTeleCallerNote = dealFilterSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_telecaller_notes &&
            current.lead_telecaller_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_telecaller_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_telecaller_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestCounsilorNote = dealFilterSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_counsilor_notes &&
            current.lead_counsilor_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_counsilor_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_counsilor_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date

      const latestMarketingNote = dealFilterSuccess?.allLeads?.reduce(
        (latest, current) => {
          // Check if the current object has telecaller notes
          if (
            current.lead_marketing_notes &&
            current.lead_marketing_notes.length > 0
          ) {
            // Find the latest note in the current object's telecaller notes
            const latestInCurrent = current.lead_marketing_notes.reduce(
              (latestNote, currentNote) =>
                new Date(currentNote.createdAt) > new Date(latestNote.createdAt)
                  ? currentNote
                  : latestNote,
              current.lead_marketing_notes[0]
            );

            // Compare with the overall latest note
            return new Date(latestInCurrent.createdAt) >
              new Date(latest.createdAt)
              ? latestInCurrent
              : latest;
          }

          return latest;
        },
        { createdAt: "1970-01-01T00:00:00.000Z" }
      ); // Start with a very old date
      setCounsilorNote(latestCounsilorNote);
      setTeleCallerNote(latestTeleCallerNote);
      setMarketingNote(latestMarketingNote);
    }
    
  }, [dealFilterSuccess, reset]);

  useEffect(() => {
    setData(
      leadData
        ?.map((lead, index) => {
            return {
              id: lead.id,
              sl: index + 1,
              name: lead?.firstName,
              email: lead.email,
              phone: lead.mobileNumber,
              whatsappNumber: lead.whatsappNumber,
              passportNumber: lead.lead_personal_details?.[0]?.passportNumber,
              tags: lead?.DuplicateLead,
              registrationFeeTag: lead?.registrationFeeApproval,
              tutionFeeTag: lead?.tuitionFeeApproval,
              deferralTag: lead?.deferralApproval,
              enrollTag: lead?.leadEnrollmentApprovalStatus,
              dropTag: lead?.dropApproval,
              ownerChangeTag: lead?.ownerChangeApproval,
              leadEmailEditTag: lead?.leadEmailApproval,
              isSourceEdit: lead?.IsleadSourceChanged,
              leadSourceEditTag: lead?.leadSourceApproval,
              leadPhoneNumberEditTag: lead?.leadPhoneNumberApproval,
              leadDocumentEditTag: lead?.leadDocumentApproval,
              leadPassportVerifyTag: lead?.isPassportVerificationRequest,
              leadPassportEditTag: lead?.leadPassportEdit,
              preferredCountry: lead.preferredCountryId,
              leadSource: lead.leadSource,
              leadRecallStatus: lead?.leadRecallStatus,
              leadOwner:
                loginFindSuccess?.role?.roleName !== "branch manager"
                  ? lead.leadOwnerName
                    ? lead.leadOwnerName
                    : "-"
                  : null,
              status: lead.status,
              priority: lead.priority ? lead.priority : "-",
              leadCity: lead.location,
              branchId: lead.branchId,
              leadBranch: lead?.branch_master?.branchName
                ? lead?.branch_master?.branchName
                : "-",
              applicationStatus: lead?.lead_applied_short_lists,
              leadCounsilor:
                loginFindSuccess?.role?.roleName !== "counsellor"
                  ? lead?.counsilorID
                    ? lead?.counsilorID
                    : "-"
                  : null,
              CounsilorNote:
                counsilorNote?.leadId == lead?.id
                  ? counsilorNote?.counsilorNote
                  : "-",
              leadTeleCaller:
                loginFindSuccess?.role?.roleName !== "tele caller" ||
                loginFindSuccess?.isTeleCallerTeamLead == true ||
                loginFindSuccess?.isTelecallerManager == true
                  ? lead?.teleCallerId
                    ? lead?.teleCallerId
                    : "-"
                  : null,
              TeleCallerNote:
                teleCallerNote?.leadId == lead?.id
                  ? teleCallerNote?.teleCallerNote
                  : "-",

              marketingNote:
                marketingNote?.leadId == lead?.id
                  ? marketingNote?.marketingNote
                  : "-"
            };
          // }
          // return null;
        })
        .filter(Boolean)
    );
  }, [leadData]);

  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim()
      setSearchValue(newSearchValue);

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(dealsFindAction(pagiantionEntry, paginationPageNumber))
        return;
      }

      setPaginationPageNumber(1)

    } catch (error) {
      console.error(error);
    }
  }

  const searchHandleChange = async(e) => {
    try {
      const newSearchValue = e.target.value.trim();

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(dealsFindAction(pagiantionEntry, paginationPageNumber));
        return;
      }
      
      setSearchValue(newSearchValue);
      setSearchPagination(true);
      setFilterPagination(false);
      
      fetchSearchResults(newSearchValue, paginationPageNumber);

    } catch(error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNum) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;
        
      const { data } = await axios.get(`/api/admin/lead/searchdeal?q=${value}&
        limit=${pagiantionEntry}&pagenumber=${pageNum}&id=${UserId}`, config)

      setSearchPaginationCount(data?.totalCount);
      setLeadData(data?.payload);
    } catch (error) {
      console.error(error);
    }
  };

  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);

  // material Table
  const columns = [
    {
      title: "Sl no",
      field: "sl"
    },
    {
      title: "Name",
      field: "name",
      // hidden: showNameColumn
    },
    {
      title: "Email",
      field: "email",
      // hidden: showEmailColumn
    },
    {
      title: "Phone     ",
      field: "phone",
      // hidden: showPhoneColumn
    },

    {
      title: "What's App Number",
      field: "whatsappNumber",
      // hidden: showWhatsAppNumColumn
    },
    {
      title: "Passport number",
      field: "passportNumber",
      // hidden: showWhatsAppNumColumn
    },
    {
      title: "Tags",
      field: "Tags",
      // hidden: showLeadBranchColumn
    },
    {
      title: "Preferred Country",
      field: "preferredCountry",
      // hidden: showPrefferedColumn
    },
    {
      title: "Lead Source",
      field: "leadSource",
      // hidden: showLeadSourceColumn
    },
    {
      title:
        loginFindSuccess?.role?.roleName !== "branch manager"
          ? "Lead Owner"
          : null,

      field: "leadOwner",
      // hidden: showLeadOwnerColumn
    },
    {
      title: "Lead Branch",
      field: "leadBranch",
      // hidden: showLeadBranchColumn
    },
    {
      title: "Status",
      field: "status",
      // hidden: showStatusColumn
    },
    {
      title: "Priority",
      field: "priority",
      // hidden: showPriorityColumn
    },
    {
      title: "Lead Place",
      field: "leadCity",
      // hidden: showLeadPlaceColumn
    },
    {
      title:
        loginFindSuccess?.role == null ||
        loginFindSuccess?.isManager ||
        loginFindSuccess?.role?.roleName !== "tele caller" ||
        loginFindSuccess?.isTeleCallerTeamLead == true ||
        loginFindSuccess?.isTelecallerManager == true
          ? "TeleCaller"
          : null,
      field: "TeleCaller",
      // hidden: showTelecallerColumn
    },
    {
      title: "Telecaller note",
      field: "telecallerNote",
      // hidden: showLeadPlaceColumn
    },
    {
      title:
        loginFindSuccess?.role == null ||
        loginFindSuccess?.isManager ||
        loginFindSuccess?.role?.roleName !== "counsellor"
          ? "Counsilor"
          : null,
      field: "Counsilor",
      // hidden: showCounsilorColumn
    },
    {
      title: "Counsilor note",
      field: "counsilorNote",
      filtering: false
    },
    {
      title: "Marketing note",
      field: "marketingNote",
      filtering: false
    },
    {
      title: "",
      field: "action",
      filtering: false
    }
  ];

  const excelDownloadClick = () => {
    const filteredColumns = columns.filter(
      (column) => column.field !== "Tags" && column.field !== "action"
    );

    DownloadExcel(filteredColumns, data, "Deal_Managment");
  };

  const pdfDownloadClick = () => {
    const excludedFields = ["sl", "Tags", "action", "telecallerNote", "counsilorNote", "marketingNote"];
    const filteredColumns = columns.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    );   

    DownloadPdf(filteredColumns, data, "Deal_Management", "Deals Lead Details");
  };

  const toggleNameColumn = (status, columnName) => {
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName)
          ? prevColumns
          : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  const LeadFilterFunction = (filterData) => {
    try {      
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      if (dealFindSuccess?.allLeads?.length === 0 || dealFindSuccess !== undefined) {
        setFilterPagination(true);
      } else {
        setFilterPagination(false);
      }
      setPaginationPageNumber(1);
      dispatch(dealFilterAction(filterData, pagiantionEntry, 1));
    } catch(error) {
      console.error(error);
    }
  }

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(dealsFindAction(pagiantionEntry, 1));
  };

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      console.log(620,'search');
      
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      console.log(620,'filter');
      dispatch(dealFilterAction(currentFilterData, value, 1));
    } else {
      console.log(620,'else');
      dispatch(dealsFindAction(value, 1));
    }
  };

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };
  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        
        dispatch(dealFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(dealsFindAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };
  console.log(662,filterPagination);

  if (!hasPrivilege("Deals") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <LeadersSearchHeader
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        component="deals"
        leadId={leadId}
        subMenu="Deals"
        column={columns}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      {/* <div style={{display:"flex",justifyContent:"space-evenly", width:"auto"}}> */}
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="lead"
            data={dealsFindWithoutPaginationSuccess?.allLeads}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
            component="deals"
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
        {dealsFindLoading ? (
          <Loader />
        ) : data?.length === 0 ? (
          <TableNoItemComponent />
        ) : (
          <LeadsTable
            toggle={props.toggle}
            reset={reset}
            setIdsFunction={setIdsFunction}
            data={data}
            columns={
              columnVisibilityData?.length > 0 ? columnVisibilityData : columns
            }
            leadFindLoading={dealsFindLoading}
            selectBoxIdPassHandler={selectBoxIdPassHandler}
            isExistCounsilor={loginFindSuccess}
            component="deals"
            pagiantionEntry={pagiantionEntry}
            paginationPageNumber={paginationPageNumber}
            subMenu="Deals"
            mainMenu="deals"
            viewedColumn={viewedColumn}
            totalLeadCount={
              searchPagination ? searchPaginationCount : 
              filterPagination ? dealFilterSuccess?.totalCount :
              dealFindSuccess?.totalCount
            }
            paginationDataFetching={paginationDataFetching}
            searchPagination={searchPagination}
          />
        )}
        </Grid>
      </Grid>
    </>
  );
}

export default DealsMain;
